import z from 'zod';
import { ImageTs } from '../../common';



//contact-us-card
export type ContactUsCard = z.output<typeof ContactUsCardSchema>;
export const ContactUsCardSchema = z.object({
  title: z.string(),
  content: z.string(),
  byChat: z.string(),
  byEmail: z.string(),
  pictures: ImageTs.array()
});

//how-it-works-item
export type HowItWorksItem = z.output<typeof HowItWorksItemSchema>;
export const HowItWorksItemSchema = z.object({
  title: z.string(),
  content: z.string(),
});

//how-it-works
export type HowItWorks = z.output<typeof HowItWorksSchema>;
export const HowItWorksSchema = z.object({
  title: z.string(),
  howItWorksItems: HowItWorksItemSchema.array(),
  cta: z.string(),
});


//pro-items
export type ProItem = z.output<typeof ProItemSchema>;
export const ProItemSchema = z.object({
  content: z.string(),
});

//shipping-target-card
export type ShippingTargetCard = z.output<typeof ShippingTargetCardSchema>;
export const ShippingTargetCardSchema = z.object({
  title: z.string(),
  proTitle: z.string(),
  proItems: ProItemSchema.array(),
  customerTitle: z.string(),
  customerItems: ProItemSchema.array(),
  // customerPicture: ImageTs,
  cta: z.string(),
  proPicture: ImageTs,
  customerPicture: ImageTs

  // pictures: ImageTs.array()
});

//why-zapptax-item
export type WhyZapptaxItem = z.output<typeof WhyZapptaxItemSchema>;
export const WhyZapptaxItemSchema = z.object({
  title: z.string(),
  content: z.string()
});
//why-zapptax-card
export type WhyZapptaxCard = z.output<typeof WhyZapptaxCardSchema>;
export const WhyZapptaxCardSchema = z.object({
  title: z.string(),
  items: WhyZapptaxItemSchema.array(),
  cta: z.string(),
});

//pricing-section-item
export type ShipppingPricingSectionItem = z.output<typeof ShipppingPricingSectionItemSchema>;
export const ShipppingPricingSectionItemSchema = z.object({
  text: z.string(),
});

//pricing-section
export type ShipppingPricingSection = z.output<typeof ShipppingPricingSectionSchema>;
export const ShipppingPricingSectionSchema = z.object({
  title: z.string(),
  info: z.string(),
  cta: z.string(),
  content: ShipppingPricingSectionItemSchema.array(),
});
